import { render, staticRenderFns } from "./AnnotationToolbar.vue?vue&type=template&id=979400aa&scoped=true"
import script from "./AnnotationToolbar.vue?vue&type=script&lang=js"
export * from "./AnnotationToolbar.vue?vue&type=script&lang=js"
import style0 from "./AnnotationToolbar.vue?vue&type=style&index=0&id=979400aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979400aa",
  null
  
)

export default component.exports